import type { HistorySummary } from '../../../../historical-billing.ts';
type Month = HistorySummary['months'][number];
export function invoiceDate(value?:string):string|null {
  if (!value || !Number.isFinite(new Date(value).valueOf())) return null;
  return new Date(value).toLocaleDateString('en-IE',{day:'numeric',month:'long',timeZone:'UTC'});
}
export function monthPaymentState(m:Month):string {
  if (m.payment?.status==='review' || m.payment?.invoice?.reviewReason) return 'Needs attention';
  if (!m.payment?.invoice && (m.payment?.status==='pending' || m.payment?.status==='creating')) return 'Processing';
  if (m.openCents===0 && m.unpricedCount>0) return 'Quote pending';
  if (m.openCents===0 && m.payableCents>0 && m.creditedCents>=m.payableCents) return 'Covered by credit';
  if (m.approvalStatus==='paid') return 'Paid';
  if (m.approvalStatus==='not_charged') return 'Not charged';
  if (m.payment?.invoice?.status==='draft') return 'Preparing invoice';
  if (m.payment?.invoice && !['open','paid'].includes(m.payment.invoice.status)) return 'Needs attention';
  if (m.approvalStatus==='pending') return 'Pending approval';
  if (m.payment?.status==='declined') return 'Payment declined';
  return 'Unpaid';
}
export function isPayableInvoice(m:Month):boolean {
  return m.openCents>0 && m.approvalStatus==='approved' && monthPaymentState(m)==='Unpaid' && m.payment?.invoice?.status==='open' && !!m.payment.invoice.hostedUrl;
}
function firstDue(months:Month[]):Month|undefined {
  return [...months].sort((a,b)=>{
    const date=(m:Month)=>invoiceDate(m.payment?.invoice?.dueAt) ? new Date(m.payment!.invoice!.dueAt!).valueOf() : Infinity;
    return date(a)-date(b) || a.month.localeCompare(b.month);
  })[0];
}

export function nextPayableInvoice(months:Month[]):Month|undefined {
  return firstDue(months.filter(isPayableInvoice));
}
export function nextUnpaidInvoice(months:Month[]):Month|undefined {
  return firstDue(months.filter(m=>m.openCents>0 && m.payment?.invoice?.status==='open' && !!invoiceDate(m.payment.invoice.dueAt)));
}
